export const formatDateByLocale = (time: Date, locale: string) => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };

  return new Intl.DateTimeFormat(locale, options).format(time);
};

export const convertStringToDate = (dateStr:string): Date => {
  const year = parseInt(dateStr.substring(0, 4));
  const month = parseInt(dateStr.substring(4, 6)) - 1; // JavaScriptの月は0から始まるため、1を引く
  const day = parseInt(dateStr.substring(6, 8));
  const hour = parseInt(dateStr.substring(8, 10));
  // 新しいDateオブジェクトを作成
  return new Date(year, month, day, hour);
}

export const getRoundedCurrentTime = () => {
  const now = new Date();
  now.setMinutes(0);
  now.setSeconds(0);
  now.setMilliseconds(0);
  return now;
};

export const findClosestTimepoint = (currentDate: Date): Date => {
  const timepoints = [0, 3, 6, 9, 12, 15, 18, 21];

  // 現在の時間を取得
  const currentHour = currentDate.getHours();

  // 現在の時間以前で最も近いtimepointを探す
  const closestTimepointHour = timepoints
    .slice() // timepoints配列のコピーを作成
    .reverse() // 配列を逆順にする
    .find(tp => currentHour >= tp); // 現在の時間以上で最も近い値を探す

  // 最も近いtimepointのDateオブジェクトを作成
  const closestTimepoint = new Date(currentDate);
  closestTimepoint.setHours(closestTimepointHour || 0, 0, 0, 0); // 分、秒、ミリ秒を0に設定

  return closestTimepoint;
};


export const convertTimeToAssetId = (dateTime:Date):string => {
  const dateUTC = convertLocalTimeToUTC(dateTime);
  const year = dateUTC.getFullYear();
  const month = dateUTC.getMonth() + 1; // getMonth() は 0 から始まるので +1
  const day = dateUTC.getDate();
  const hour = dateUTC.getHours();

  // 数値を2桁の文字列に変換
  const monthStr = month.toString().padStart(2, '0');
  const dayStr = day.toString().padStart(2, '0');
  const hourStr = hour.toString().padStart(2, '0');

  // 文字列を組み立て
  const assetId = `te_flddph_${year}${monthStr}${dayStr}${hourStr}`;
  return assetId;
}

// 上の逆関数: assetIDからDateオブジェクトを取得（assetIDは UTCで DateObjはlocal timeになる）
export const convertAssetIDToLocalTime = (str: string): Date | null => {
  if (!str){
    return null
  }
  // "te_flddph_" 以降の部分を取得
  const dateString = str.substring(10);

  // 年、月、日、時を抽出
  const year = parseInt(dateString.substring(0, 4));
  const month = parseInt(dateString.substring(4, 6)) - 1; // JavaScriptの月は0から始まるため、1を引く
  const day = parseInt(dateString.substring(6, 8));
  const hour = parseInt(dateString.substring(8, 10));

  // 新しいDateオブジェクトを作成
  const dateUTC = new Date(year, month, day, hour);
  const localDate = new Date(dateUTC.getTime() - dateUTC.getTimezoneOffset() * 60000);
  return localDate
};


// この関数はUTC <=> Localの変換を行わない
export const createTimeString = (dateTime:Date):string => {
  const year = dateTime.getFullYear();
  const month = dateTime.getMonth() + 1; // getMonth() は 0 から始まるので +1
  const day = dateTime.getDate();
  const hour = dateTime.getHours();
  // 数値を2桁の文字列に変換
  const monthStr = month.toString().padStart(2, '0');
  const dayStr = day.toString().padStart(2, '0');
  const hourStr = hour.toString().padStart(2, '0');
  return `${year}${monthStr}${dayStr}${hourStr}`;
}

// returns Date2 - Date1 
export function getDifferenceInHours(date1: Date, date2: Date): number {
  const diffInMilliseconds: number = date2.getTime() - date1.getTime();
  const diffInHours: number = diffInMilliseconds / (1000 * 60 * 60);
  return diffInHours;
}

export const formatDateStringToYearMonthDate = (dateString: string, lang="ja") => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  if (lang === "ja") {
    return `${year}年${month}月${day}日`;
  }
  else {
    return `${year}-${month}-${day}`;
  }
}

export const timeDelta = 9  // JSTの場合。GMTから進んでいる分を正とする。

export const convertLocalTimeToUTC = (date: Date) => {
  const utc = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  return utc;
}

